import { useTranslation } from 'react-i18next';

export default function TermsPage() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-center">{t('nav.terms')}</h1>

        <div className="bg-white rounded-lg shadow-md p-8 space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">
              {isRTL ? 'מבוא' : 'Introduction'}
            </h2>
            <p className="text-gray-600 leading-relaxed">
              {isRTL
                ? 'ברוכים הבאים לאתר קנייה חכמה. באמצעות גישה לאתר זה, אתם מסכימים להיות מחויבים לתנאי השימוש והתקנות הללו, לכל החוקים והתקנות החלים.'
                : 'Welcome to Smart Shopping. By accessing this website, you agree to be bound by these terms of use and regulations, and all applicable laws and regulations.'}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              {isRTL ? 'שימוש באתר' : 'Use of Website'}
            </h2>
            <p className="text-gray-600 leading-relaxed">
              {isRTL
                ? 'האתר מספק פלטפורמה למציאת מוצרים ומבצעים. אנו לא מוכרים מוצרים ישירות אלא מפנים לספקים חיצוניים. כל רכישה מתבצעת ישירות מול הספק.'
                : 'This website provides a platform for finding products and deals. We do not sell products directly but redirect to external suppliers. All purchases are made directly with the supplier.'}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              {isRTL ? 'אחריות' : 'Liability'}
            </h2>
            <p className="text-gray-600 leading-relaxed">
              {isRTL
                ? 'אנו לא נושאים באחריות לאיכות המוצרים, זמני המשלוח או כל בעיה אחרת הנוגעת לספקים החיצוניים. מומלץ לבדוק את דירוג הספק ומדיניות ההחזרות לפני הרכישה.'
                : 'We are not responsible for product quality, shipping times, or any other issues related to external suppliers. It is recommended to check supplier ratings and return policies before purchasing.'}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              {isRTL ? 'פרטיות' : 'Privacy'}
            </h2>
            <p className="text-gray-600 leading-relaxed">
              {isRTL
                ? 'אנו מכבדים את פרטיותכם. המידע שתספקו ישמש רק למטרת שיפור השירות והתאמה אישית של חווית המשתמש.'
                : 'We respect your privacy. The information you provide will only be used to improve our service and personalize your user experience.'}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              {isRTL ? 'שינויים בתנאים' : 'Changes to Terms'}
            </h2>
            <p className="text-gray-600 leading-relaxed">
              {isRTL
                ? 'אנו שומרים לעצמנו את הזכות לעדכן את תנאי השימוש בכל עת. שינויים יכנסו לתוקף מיד עם פרסומם באתר.'
                : 'We reserve the right to update these terms of use at any time. Changes will take effect immediately upon publication on the website.'}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              {isRTL ? 'יצירת קשר' : 'Contact'}
            </h2>
            <p className="text-gray-600 leading-relaxed">
              {isRTL
                ? 'לשאלות או הבהרות בנוגע לתנאי השימוש, ניתן ליצור איתנו קשר בדוא"ל: smartshoppingil2026@gmail.com'
                : 'For questions or clarifications regarding the terms of use, you can contact us at: smartshoppingil2026@gmail.com'}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
